<template>
  <el-form-item :label="item.name + ':'" :required="item.required">
    <el-select
      :style="input_width"
      size="small"
      v-model="mData"
      filterable
      remote
      :placeholder="$t('message.placeholder.input')"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="selectMF"
    >
      <el-option
        v-for="item in options"
        :key="item.index"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button-group>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchManuFact = true"
      ></el-button>
      <el-button
        type="primary"
        icon="el-icon-document-add"
        @click="createManuFact = true"
      ></el-button>
    </el-button-group>
    <el-dialog
      class="searchAddBomList"
      v-if="searchManuFact"
      :title="$t('message.title.add')"
      :visible.sync="searchManuFact"
      :append-to-body='true'
    >
      <SearchMf @listDbClick="addList"></SearchMf>
    </el-dialog>
    <el-dialog
      class="searchAddBomList"
      v-if="createManuFact"
      :title="$t('message.title.create')"
      :visible.sync="createManuFact"
      :append-to-body='true'
    >
      <CreateMf @getMFid="getMFData"></CreateMf>
    </el-dialog>
  </el-form-item>
</template>

<script>
import axios from "axios";
import SearchMf from "@/components/searchMf.vue";
//import CreateMf from "";
export default {
  data() {
    return {
      input_width: {
        width: "50%",
      },
      options: [],
      value: [],
      list: [],
      loading: true,
      searchManuFact: false,
      createManuFact: false,
      mData: "",
    };
  },
  components: {
    SearchMf,
    CreateMf:()=>import('./createMf.vue'),
  },
  props: ["item"],
  methods: {
    getMFlist(){
      axios.get("/pmdm/manufacturers/getManufacturers?name="+ '*')
      .then(res => {
        console.log(480,res);
        this.states = res.data.object.manufacturers;
        this.list = this.states.map(i => {
          return { 'value': i.id, 'label': i.name };
        });
        this.options = this.list;
        this.loading = false;
        // console.log(this.list);
      })  
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    selectMF(e) {
      console.log(e);
      let obj = this.list.filter(i => i.value == e)[0]
      console.log(obj);
      this.$emit('change',obj)
      // this.mData_ = true;
      // console.log(this.mData);
      // console.log('options',this.options);
    },
    addList(row) {
      //添加
      console.log(row);
      // this.MFid = 0;
      // this.searchMf = row.name;
      this.options.push({ value: row.id, label: row.name });
      this.searchManuFact = false;
      this.mData = row.id;
      this.mData_ = false;
      this.$emit('change',{ value: row.id, label: row.name })
    },
    getMFData(e) {
      console.log(619, e);
      this.createManuFact = false;
      axios.get("/pmdm/manufacturers/getManufacturers?name=" + "*").then((res) => {
        //console.log(res);
        this.states = res.data.object.manufacturers;
        this.list = this.states.map((item) => {
          return { value: `${item.id}`, label: `${item.name}` };
        });
        console.log(this.list);
        let obj = this.list.find((i) => {
          return i.value == e.id;
        });
        this.options.push(obj);
        console.log("options", this.options);
        this.mData = this.options[0].value;
        this.$emit('change',this.options[0])
      });
    },
  },
  created(){
    this.getMFlist()
  }
};
</script>

<style></style>
